export function searchUrlParam(param) {
  const params = new URLSearchParams(window.location.search);
  return params.get(param) || null;
}

export function getSourceClick() {
  const clickIds = ['gclid', 'fbclid', 'ttclid', 'msclkid', 'twclid', 'wbraid', 'gbraid'];

  for (const source of clickIds) {
    const value = searchUrlParam(source);
    if (value) {
      return {
        source_click_id: value,
        source_click_type: source,
      };
    }
  }

  return {
    source_click_id: '',
    source_click_type: '',
  };
}

export function getCookie(name) {
  if (!window) {
    return;
  }
  const cookie = window?.document.cookie.split('; ').find((row) => row.startsWith(`${name}=`));

  return cookie ? cookie.split('=')[1] : null;
}

export function setCookie(key, value) {
  const oneYear = 365 * 24 * 60 * 60;

  document.cookie =
    `${key}=${value}` + `; Path=/` + `; Max-Age=${oneYear}` + `; SameSite=Lax` + `; Secure`;
}
